import * as React from "react"
import { Modal } from "react-bootstrap"
import { toast } from "react-toastify"
import { RandomPersonnelAddPersonObservable, RandomPersonnelGridResponse } from "../../api/Randoms/RandomPersonnelListGet"
import RandomPersonnelAdd from "../../api/Randoms/RandomPersonnelAdd"
import RandomPersonnelGridOptions from "../../api/Randoms/RandomPersonnelModel/RandomPersonnelGridOptions"
import EmploymentDetails from "../EmploymentDetails"
import EmploymentDetailsEdit from "../../api/Randoms/RandomPersonnelModel/EmploymentDetailsEdit"
import FormatDate from "../../formatters/FormatDate"

interface AddIndividualModalProps {
  show: boolean
  onAdd: () => void
  onCancel: () => void
}

export default class AddIndividualModal extends React.Component<AddIndividualModalProps, { saving: boolean }> {
  state = { saving: false }
  emptyData: EmploymentDetailsEdit = {
    Employer: "",
    Driver: "",
    SSN: "",
    Alternate: "",
    Occupation: "",
    Inactive: false,
    FirstName: "",
    LastName: "",
    Address1: "",
    Address2: "",
    City: "",
    Zip: "",
    Province: "",
    WPhone: "",
    HPhone: "",
    CPhone: "",
    Email: "",
    Gender: ""
  }

  handleSave = (data: EmploymentDetailsEdit) => {
    data.SSN = data.SSN.replace(/\D/g, '')

    const search = (data: EmploymentDetailsEdit): { field: string, text: string } => {
      switch (data.selectedCompany?.PrimaryIDType || "") {
        case "EmployerID":
          return { field: "Employer ID", text: data.Employer }
        case "SSN":
          return { field: "SSN", text: data.SSN }
        case "DriverID":
          return { field: "Driver ID", text: data.Driver }
        case "AlternateID":
          return { field: "Alternate ID", text: data.Alternate }
      }
      return { field: "", text: "" }
    }
    const params: RandomPersonnelGridOptions = {
      search: search(data),
      sort: { column: "", order: "" },
      filters: [],
      columnFilters: [],
      pageNumber: 1,
      pageSize: 20,
      isConsortium: false,
      forceReload: false
    }
    this.setState({ saving: true })
    RandomPersonnelAddPersonObservable(params).subscribe(
      ((result: RandomPersonnelGridResponse) => {
        if (result.Records.length > 0) {
          this.setState({ saving: false })
          toast.error("Person already present. Please add another.")
        } else {
          this.addPersonnel(data)
        }
      }),
      (error: string) => {
        this.setState({ saving: false })
        toast.error(error)
      }
    )
  }

  addPersonnel = (data: EmploymentDetailsEdit) => {
    const phoneString = (phone: string): string => {
      if (phone.toLowerCase() === "np" || phone.toLowerCase() === "n/p") {
        return "N/P"
      } else {
        phone = phone.replace(/\D/g, "")
        return phone.length === 10 ? phone : "N/P"
      }
    }

    const primaryIDKeys = (data: EmploymentDetailsEdit): { PrimaryIDType: string, PrimaryIDValue: string } => {
      switch (data.selectedCompany?.PrimaryIDType || "") {
        case "EmployerID":
          return { PrimaryIDType: "EmployerID", PrimaryIDValue: data.Employer }
        case "SSN":
          return { PrimaryIDType: "SSN", PrimaryIDValue: data.SSN }
        case "DriverID":
          return { PrimaryIDType: "DriverID", PrimaryIDValue: data.Driver }
        case "AlternateID":
          return { PrimaryIDType: "AlternateID", PrimaryIDValue: data.Alternate }
      }
      return { PrimaryIDType: "", PrimaryIDValue: "" }
    }

    const params: EmploymentDetailsEdit = {
      ...primaryIDKeys(data),
      AccountID: data.selectedCompany?.AccountID || 0, // TODO VALUESTORAGE.ACCOUNT_ID
      Employer: data.Employer,
      Driver: data.Driver,
      SSN: data.SSN.replace(/\D/g, ''),
      Alternate: data.Alternate,
      Company:  data.selectedCompany?.Name || "",
      CompanyID: data.selectedCompany?.AccountID || 0,
      Region: data.selectedRegion?.Name || "",
      RegionID: data.selectedRegion?.AccountID || 0,
      Location: data.selectedLocation?.Name || "",
      LocationID: data.selectedLocation?.AccountID || 0,
      Supervisor1ID: data.selectedSupervisor1?.ContactID || 0,
      Supervisor1: data.selectedSupervisor1?.FullName || "",
      Supervisor2ID: data.selectedSupervisor2?.ContactID || 0,
      Supervisor2: data.selectedSupervisor2?.FullName || "",
      Occupation: data.Occupation,
      HireDate: FormatDate(data.HireDate),
      Inactive: data.Inactive,
      FirstName: data.FirstName.replace(/^\s+|\s+$/gm, "").replace(/\s+/g, " "),
      LastName: data.LastName.replace(/^\s+|\s+$/gm, "").replace(/\s+/g, " "),
      Gender: data.Gender,
      DOB: FormatDate(data.DOB),
      Address1: data.Address1,
      Address2: data.Address2,
      City: data.City,
      StateID: data.state?.StateProvinceTerritoryID || 0,
      Zip: data.Zip,
      Province: data.Province,
      WPhone: phoneString(data.WPhone),
      HPhone: phoneString(data.HPhone),
      CPhone: phoneString(data.CPhone),
      Email: data.Email,
      PreEmploymentTest: false,
      CompanyPrimaryID: null
    }
    RandomPersonnelAdd(params).subscribe(
      ((result) => {
        this.setState({ saving: false })
        if (Number(result) > 0) {
          toast.success("Added member successfully.")
          this.props.onAdd()
        } else {
          toast.error(result)
        }
      }),
      (error: string) => {
        this.setState({ saving: false })
        toast.error(error)
      }
    )
  }

  render() {
    return <Modal backdrop="static" size="lg" centered show={this.props.show} onHide={this.props.onCancel} >
      <Modal.Header closeButton>
        <Modal.Title>ADD INDIVIDUAL</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EmploymentDetails data={this.emptyData} isSaving={this.state.saving} onCancel={this.props.onCancel} onSave={this.handleSave} />
      </Modal.Body>
    </Modal >
  }
}
